import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select, { components } from 'react-select';
import Button from 'react-bootstrap/Button';
import styled from 'styled-components';
import AdminMaster from "../../../Layout/admin/Master";
import { useMemo } from "react";
import { useEffect } from "react";
import { getOfflineStatusData, getSFTPClientListData, pullSFTPFileManually, resetSFTPFileManually } from "../../../Redux/sftpClient/action";
import axiosInstance from "../../../axiosInstance";
import { SFTP_CLIENT_LIST_URL } from "../../../api";
import { OverlayTrigger, Stack, Toast, ToastContainer } from "react-bootstrap";
import moment from "moment";
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi';
import { FaSpinner } from 'react-icons/fa'; // Spinner icon
import SweetAlert from "react-bootstrap-sweetalert";
import { Tooltip } from '@mui/material';
import { GrPowerReset } from "react-icons/gr";
import 'rsuite/dist/rsuite.min.css';
import queueDatatableCustomStyles from "../../../Layout/Elements/QueueDatatableCustomStyles";
import { getFileMonitoringTable } from "../../../Redux/Ffilemonitoring/action";
import { DateRangePicker } from "rsuite";
import { classNames } from "@react-pdf-viewer/core";
import { addDays, addMonths, endOfMonth, endOfWeek, endOfYear, setHours, setMinutes, setSeconds, startOfMonth, startOfWeek, startOfYear, subDays } from "date-fns";
import ClientDropDown from "../../common/PartnerClientFacilityDropDown/ClientDropDown";
import FacilityDropDown from "../../common/PartnerClientFacilityDropDown/FacilityDropDown";
import { useFormik } from "formik";
import FilterComponent from "../../common/FilterComponent";
import useFilter from "../../../hooks/useFilter";
import PartnerDropDown from "../../common/PartnerClientFacilityDropDown/PartnerDropDown";
import { BiExport } from "react-icons/bi";
import TableHeadings from "../../common/TableHeadings";
import * as Yup from 'yup';
import { downloadFile } from "../Dashboard/functions";

// const FilterComponent = ({ filterText, onFilter, onClear }) => (

//     <>
//         <TextField

//             id="search"
//             className="form-control form-control-solid w-250px filter-btn-custom"
//             type="text"
//             placeholder="Filter By Name"
//             aria-label="Search Input"
//             value={filterText}
//             onChange={onFilter}
//         />
//         <ClearButton type="button" onClick={onClear}>
//             X
//         </ClearButton>

//     </>
// );
const predefinedBottomRanges = [
    {
        label: 'Today',
        value: [new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)],
        placement: 'left'
    },
    {
        label: 'Yesterday',
        value: [addDays(new Date().setHours(0, 0, 0, 0), -1), addDays(new Date().setHours(23, 59, 59, 59), -1)],
        placement: 'left'
    },
    {
        label: 'This week',
        value: [startOfWeek(new Date().setHours(0, 0, 0, 0)), new Date()],
        placement: 'left'
    },
    {
        label: 'Last 7 days',
        value: [subDays(new Date().setHours(0, 0, 0, 0), 6), new Date()],
        placement: 'left'
    },
    {
        label: 'Last 30 days',
        value: [subDays(new Date().setHours(0, 0, 0, 0), 29), new Date()],
        placement: 'left'
    },
    {
        label: 'This month',
        value: [startOfMonth(new Date().setHours(0, 0, 0, 0)), new Date()],
        placement: 'left'
    },
    {
        label: 'Last month',
        value: [startOfMonth(addMonths(new Date().setHours(0, 0, 0, 0), -1)), endOfMonth(addMonths(new Date(), -1))],
        placement: 'left'
    },
    {
        label: 'This year',
        value: [new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0), new Date()],
        placement: 'left'
    },
    {
        label: 'Last year',
        value: [setSeconds(setMinutes(setHours(startOfYear(new Date(new Date().getFullYear() - 1, 0, 1)), 0), 0), 0), setSeconds(setMinutes(setHours(endOfYear(new Date(new Date().getFullYear(), 0, 0)), 23), 59), 59)],
        placement: 'left'
    },

    {
        label: 'Last week',
        closeOverlay: false,
        value: value => {
            const [start = new Date().setHours(0, 0, 0, 0)] = value || [];
            return [
                addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
            ];
        },
        appearance: 'default'
    },
    {
        label: 'Next week',
        closeOverlay: false,
        value: value => {
            const [start = new Date()] = value || [];
            return [
                addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
                addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
            ];
        },
        appearance: 'default'
    }
];
const TextField = styled.input`
    height: 32px;
    width: 200px;
    &:hover {
        cursor: pointer;
    }
    `;
const ClearButton = styled(Button)`
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
	border-top-right-radius: 5px;
    border-left: 0;
    color: #1ba1a7;
	border-bottom-right-radius: 5px;
	height: 35px;
	width: 32px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
    background-color: #f5f8fa;
    border-color: #d9d9d9;
    &:hover {
        background-color: #f5f8fa;
        border-color: #d9d9d9;
        color: #1ba1a7;
    }
    &:focus {
        background-color: #f5f8fa !important;
        border-color: #d9d9d9 !important;
        color: #1ba1a7;
    }`;

const DateRangePickerComponent = (props) => {
    const {
        tooltip,
        value,
        name,
        handleChange,
        className = 'form-date-control form-control-solid b-r-1 text-dark jobmonitor-datepicker',
        placeholder = "MM/DD/YYYY - MM/DD/YYYY",
        format = 'MM/dd/yyyy',
        error,
        touched,
    } = props
    const hasError = touched && error;
    return (
        < >
            <Tooltip title={tooltip} placement="top" disableInteractive>

                <Stack direction="column" spacing={8} alignItems="flex-start"
                    style={{ maxWidth: '230px', width: '100%' }}>
                    <DateRangePicker
                        ranges={predefinedBottomRanges}
                        cleanable
                        placement="auto"
                        appearance="default"
                        format={format}
                        placeholder={placeholder}
                        className={`jobmonitor-datepicker ${hasError ? 'error-border' : ''}`}
                        name={name}
                        onChange={val => handleChange(name, val)}
                        value={value}

                    />

                </Stack>
            </Tooltip>

        </>
    )
}

const filemonitorfilter = [
    { value: '837', label: "837 Not Recived" }, { value: 'OUTPUT', label: "Output Not Send" }, { value: 'EOB', label: "EOB Not Recived" }
]
const FileMonitoring = (params) => {

    const [loader, setLoader] = useState({
        id: null,
        type: null
    });
    const filterValidationSchema = Yup.object().shape({

        // Only required (no type or length check)
        created_date_range: Yup.mixed().required('Date range is required')
    })

    const [filterText, setFilterText] = useState('');
    const [colorRow, setColorRow] = useState({});
    const [toaster, setToaster] = useState('')
    const [sortColumn, setSortColumn] = useState('client_name');
    const [isLoadingPartners, setIsLoadingPartners] = useState(false);
    const [isFocusedPartner, setIsFocusedPartner] = useState(false);

    const [sortOrder, setSortOrder] = useState('asc');
    const [searchFilters, setSearchFilters] = useState({});

    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props}>
                {isLoadingPartners ? (
                    <FaSpinner className="spinner" style={{ fontSize: "1.5em", animation: "spin 1s linear infinite" }} />
                ) : searchFormik.values?.[state]?.length > 1 ? (
                    <TbGridDots style={{ fontSize: "1.5em" }} />
                ) : (
                    <HiChevronDown style={{ fontSize: "1.5em" }} />
                )}
            </components.DropdownIndicator>
        );
    };
    // const handlePerRowsChange = async (newPerPage, page) => {

    //     setLoading(true);
    //     // const response = await axiosInstance.get(SFTP_CLIENT_LIST_URL + "?page=" + page + "&limit=" + newPerPage);
    //     // // console.log(response);
    //     // setData(response?.data);
    //     // setLimit(newPerPage);
    //     // setTotalRows(response?.data?.data?.count);
    //     fetchData(page, newPerPage, filterText, sortOrder, sortColumn)
    //     setLoading(false);

    // };

    // const handlePageChange = page => {
    //     setPageNo(page)
    //     fetchData(page, limit, filterText, sortOrder, sortColumn)
    // };
    // const handleSearchSplits = async (e) => {
    //     const { name, value } = e.target;
    //     setSearchFilters((prev) => ({
    //         ...prev,
    //         [name]: value ?? "", // Store raw date range without formatting
    //     }));
    // }
    // const fetchData = (page, pageLimit, search = '', order, column) => {
    //     setLoading(true);
    //     getFileMonitoringTable({ page, pageLimit, search, order, column })((response) => {
    //         setPageNo(page)
    //         setLimit(pageLimit)
    //         setData(response?.data);
    //         setTotalRows(response?.data?.count);
    //         setLoading(false);
    //     });

    // }

    //   const searchFormik = useFormik({
    //         initialValues: {
    //             search: "",
    //             facility:"",
    //             client: "",
    //             partner:"",
    //             created_date_range: "",
    //         },
    //         onSubmit: (values) => {
    //             console.log(values)
    //             fetchData(1, limit, values?.search, values?.client, values?.created_date_range, values?.patient_account_number, values?.status, values?.facility);
    //         }
    //     })
    const handleRowCheckClick = (row) => {
        data?.results.map((item, index) => {
            if (row?.id == item.id) {
                setColorRow(row)
            }
        })
    };

    const initialFilters = {
        partner: [],
        client: [],
        facility: [],
        created_date_range: null,
        zero_filter_type: []
    }

    const {
        searchFormik,
        handleReset,
        handleSearch,
        data, loading, pageNo, limit, totalRows,searchKeyForTable,
       
        fetchData, handlePageChange, handlePerRowsChange, setSearchedData, setData,
        handleSort,
        searchedData,
    } = useFilter(initialFilters, getFileMonitoringTable, filterValidationSchema ,true); //4th param is server side sort
   

    console.log(data,"data")

    // useEffect(() => {
    //     fetchData(1, limit, searchFormik.values);
    // }, []);


const defaultColumns = {
    // s_no: true,
    // client_name: true,
    // _837_lockbox_count: true,
    // _837_lockbox_file_size: true,
    // rev_837_lockbox_count: true,
    // _837_files_count: true,
    // _837_files_size: true,
    // rev_837_files_count:true,
    // eob_lockbox_count: true,
    // eob_lockbox_file_size: true,
    // rev_eob_lockbox_count: true,
    // output_file_count: true,
    // date:true  
'S.NO':true,
'Client':true,
'837 Lockbox Count':true,
'837 Lockbox File Size':true,
'837 Xfer RC':true,
'837 Files Count':true,
'837 Files Size':true,
'837 Files Xfer RC':true,
'EOB Lockbox Count':true,
'EOB Lockbox File Size':true,
'EOB Xfer RC':true,
'Created date':true,
'Output File Count':true,
};
  const [state, setState] = useState(defaultColumns);
    const defaultColumnOrder = [
        's_no', 'client_name', '_837_lockbox_count', '_837_lockbox_file_size',
        'rev_837_lockbox_count', '_837_file_count', '_837_file_size',
        'rev_837_files_count', 'eob_lockbox_count', 'eob_lockbox_file_size',
        'rev_eob_lockbox_count', 'date', 'output_file_count'
    ];
    const [columnOrder, setColumnOrder] = useState(defaultColumnOrder);

  const columns = useMemo(
        () => {
             const baseColumns = [
            {
                id: 's_no',
                name: (
                    <span title="S.NO" className="text-truncate d-inline-block" style={{ maxWidth: '60px' }}>
                        S.NO
                    </span>
                ),
                selector: (row, index) => pageNo == 1 ? index + 1 : (pageNo - 1) * limit + index + 1,
                width: "60px",
                wrap: true,
                omit:  !state?.['S.NO'],
                omit:  !state?.['S.NO'],
                name_copy: 'S.NO'
            },
            {
                id: 'client_name',
                name: (
                    <span title="Client" className="text-truncate d-inline-block" style={{ maxWidth: '140px' }}>
                        Client
                    </span>
                ),
                selector: row => row?.client_name,
                cell: (row) => (
                    <div className="overflow-hidden d-flex flex-row flex-wrap text-truncate" onClick={() => handleRowClick(row)} style={{ width: "140px" }}>
                        <Tooltip disableInteractive title={row?.client_name} placement='top' arrow>
                            <span className='text-truncate'>
                                {row?.client_name}
                            </span>
                        </Tooltip>
                    </div>
                ),
                sortable: true,
                left: true,
                wrap: true,
                width: '160px',
                reorder: true,
                omit:  !state?.['Client'],
                omit:  !state?.['Client'],
                name_copy: 'Client',
                sortField:'client_name',
            },
            {
                id: '_837_lockbox_count',
                name: (
                    <span title="837 Lockbox Count (client wise)" className="text-truncate d-inline-block" style={{ maxWidth: '120px' }}>
                        837 Lockbox Count (client wise)
                    </span>
                ),
                selector: row => row?._837_lockbox_count,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?._837_lockbox_count}</span>,
                sortable: true,
                right: true,
                wrap: true,
                reorder: true,
                omit:  !state?.['837 Lockbox Count'],
                omit:  !state?.['837 Lockbox Count'],
                name_copy: '837 Lockbox Count',
                sortField:'_837_lockbox_count',
            },
            {
                id: '_837_lockbox_file_size',
                name: (
                    <span title="837 Lockbox File Size  (client wise)" className="text-truncate d-inline-block" style={{ maxWidth: '130px' }}>
                        837 Lockbox File Size  (client wise)
                    </span>
                ),
                selector: row => row?._837_lockbox_file_size,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?._837_lockbox_file_size}</span>,
                sortable: true,
                right: true,
                wrap: true,
                reorder: true,
                omit:  !state?.['837 Lockbox File Size'],
                name_copy: '837 Lockbox File Size',
                sortField:'_837_lockbox_file_size',
            },
            {
                id: 'rev_837_lockbox_count',
                name: (
                    <span title="837 Transferred To RevARC (client wise)" className="text-truncate d-inline-block" style={{ maxWidth: '80px' }}>
                        837 Xfer RC (client wise)
                    </span>
                ),
                selector: row => row?.rev_837_lockbox_count,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.rev_837_lockbox_count}</span>,
                sortable: true,
                right: true,
                wrap: true,
                reorder: true,
                omit:  !state?.['837 Xfer RC'],
                name_copy: '837 Xfer RC',
                sortField:'rev_837_lockbox_count',
            },
            {
                id: '_837_file_count',
                name: (
                    <span title="837 File Count (client wise)" className="text-truncate d-inline-block" style={{ maxWidth: '100px' }}>
                        837 File Count (client wise)
                    </span>
                ),
                selector: row => row?._837_files_count,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?._837_files_count}</span>,
                sortable: true,
                right: true,
                wrap: true,
                reorder: true,
                omit:  !state?.['837 Files Count'],
                name_copy: '837 File Count',
                sortField:'_837_files_count',
            },
            {
                id: '_837_file_size',
                name: (
                    <span title="837 File Size  (client wise)" className="text-truncate d-inline-block" style={{ maxWidth: '90px' }}>
                        837 File Size (client wise)
                    </span>
                ),
                selector: row => row?._837_files_size,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?._837_files_size}</span>,
                sortable: true,
                right: true,
                wrap: true,
                reorder: true,
                omit:  !state?.['837 Files Size'],
                name_copy: '837 File Size',
                sortField:'_837_files_size',
            },
            {
                id: 'rev_837_files_count',
                name: (
                    <span title="837 Files Transferred To RevARC  (client wise)" className="text-truncate d-inline-block" style={{ maxWidth: '110px' }}>
                        837 Files Xfer RC (client wise)
                    </span>
                ),
                selector: row => row?.rev_837_files_count,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.rev_837_files_count}</span>,
                sortable: true,
                right: true,
                wrap: true,
                reorder: true,
                omit:  !state?.['837 Files Transferred RC'],
                name_copy: '837 Files Xfer RC',
                sortField:'rev_837_files_count',
            },
            {
                id: 'eob_lockbox_count',
                name: (
                    <span title="EOB Lockbox Count" className="text-truncate d-inline-block" style={{ maxWidth: '120px' }}>
                        EOB Lockbox Count
                    </span>
                ),
                selector: row => row?.eob_lockbox_count,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.eob_lockbox_count}</span>,
                sortable: true,
                right: true,
                wrap: true,
                reorder: true,
                omit:  !state?.['EOB Lockbox Count'],
                name_copy: 'EOB Lockbox Count',
                sortField:'eob_lockbox_count',
            },
            {
                id: 'eob_lockbox_file_size',
                name: (
                    <span title="EOB Lockbox File Size" className="text-truncate d-inline-block" style={{ maxWidth: '130px' }}>
                        EOB Lockbox File Size
                    </span>
                ),
                selector: row => row?.eob_lockbox_file_size,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.eob_lockbox_file_size}</span>,
                sortable: true,
                right: true,
                wrap: true,
                reorder: true,
                omit:  !state?.['EOB Lockbox File Size'],
                name_copy: 'EOB Lockbox File Size',
                sortField:'eob_lockbox_file_size',
            },
            {
                id: 'rev_eob_lockbox_count',
                name: (
                    <span title="EOB Transferred To RevARC" className="text-truncate d-inline-block" style={{ maxWidth: '80px' }}>
                        EOB Xfer RC
                    </span>
                ),
                selector: row => row?.rev_eob_lockbox_count,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.rev_eob_lockbox_count}</span>,
                sortable: true,
                right: true,
                wrap: true,
                reorder: true,
                omit:  !state?.['EOB Xfer RC'],
                name_copy: 'EOB Xfer RC',
                sortField:'rev_eob_lockbox_count',
            },
            {
                id: 'date',
                name: (
                    <span title="Created date" className="text-truncate d-inline-block" style={{ maxWidth: '100px' }}>
                        Created date
                    </span>
                ),
                selector: row => row?.date,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.date}</span>,
                sortable: true,
                right: true,
                wrap: true,
                reorder: true,
                omit:  !state?.['Created date'],
                name_copy: 'Created date',
                sortField:'date',
            },
            {
                id: 'output_file_count',
                name: (
                    <span title="Output File Count" className="text-truncate d-inline-block" style={{ maxWidth: '110px' }}>
                        Output File Count
                    </span>
                ),
                selector: row => row?.output_file_count,
                cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.output_file_count}</span>,
                sortable: true,
                right: true,
                wrap: true,
                reorder: true,
                omit:  !state?.['Output File Count'],
                name_copy: 'Output File Count',
                sortField:'output_file_count',
            },
        ];
             return baseColumns.sort((a, b) => {
                const indexA = columnOrder.indexOf(a.id);
                const indexB = columnOrder.indexOf(b.id);
                if (indexA === -1) return 1; 
                if (indexB === -1) return -1;
                return indexA - indexB;
            });
        },
        [loader, state, pageNo, data, columnOrder],
    );

    const handleColumnOrderChange = (newColumns) => {
        setColumnOrder(newColumns.map(col => col.id));
    };
  
console.log(state,'state')
    const [ToastMessage, setToastMessage] = useState({
        status: false,
        message: "",
        type: "",
    })
    const [isSwal, setIsSwal] = useState({
        status: false,
        message: "",
    })

    var i = 0;
    const conditionalRowStyles = [

        {
            when: row => { i = i + 1; return i % 2 == 0 || colorRow.id == row.id ? true : false },
            style: (row, index) => ({
                backgroundColor: colorRow?.id == row?.id ? '#dbf4f5' : '#f2f2f2',
            }),
        },

    ];
    const handleRowClick = (row) => {
        setColorRow(row);
    };

   const [exportLoader,setExportLoader] = useState(false)
    const ExtraActionPanel = () => {
        const handleExport = () => {
            if(searchFormik?.values?.created_date_range){

                let keymap = {
                    rev_837_lockbox_count: "837 XFER RC",
                    DATE: "CREATED DATE",
                    rev_837_files_count: "837 FILES XFER RC",
                    rev_eob_lockbox_count: "EOB XFER RC",
                }

               let header_names= columns?.map(item=>(keymap?.[item?.id] ? keymap?.[item?.id] : 
                item?.id.replaceAll('_'," ").trim()).toUpperCase()).join(',')

                setExportLoader(true)
                getFileMonitoringTable(pageNo,limit,searchFormik?.values,true , header_names)(response=>{
                    if(response?.status){
                        downloadFile(response?.data, `file-monitring`)
                    }
                    setExportLoader(false)
                })
            }else{
                searchFormik.setFieldTouched('created_date_range', true)

    searchFormik.validateField('created_date_range')
 
            }
        }
    console.log(searchFormik,"HHHHH");
    
    return (
        <div className="d-flex" >
            <div className="me-2">

                <TableHeadings
                    columnState={state}
                    setColumnState={setState}
                />
            </div>
            <button onClick={handleExport} className="btn btn-light btn-active-primary pb-2  jobMonitor-Buttons" type="button"  >
                {exportLoader ? (
                    <>
                        <span
                            className="spinner-border spinner-border-sm me-1"
                            role="status"
                            aria-hidden="true"
                        ></span>
                        
                    </>
                ) : (
                    <>
                        <BiExport className="me-1" />
                        
                    </>
                )}

            </button>
        </div>
    );
};
const handleSelectChange =(e) => {
   
  searchFormik.setFieldValue('zero_filter_type',e)
}
const handleCustomReset = () => {
     searchFormik.resetForm();
        setSearchedData(initialFilters);
        setData([])
        setColumnOrder(defaultColumnOrder)
        
}




    return (
        <React.Fragment>
            <AdminMaster ToastMessage={toaster} />
            <ToastContainer className="p-3" position={"top-end"}>
                <Toast bg={ToastMessage?.type} onClose={() => setToastMessage(
                    {
                        status: false,
                        message: "",
                        type: "",
                    }

                )}
                    show={ToastMessage?.status} animation={true} delay={2000} autohide>
                    <Toast.Body ><span className='text-white'>{ToastMessage?.message}</span></Toast.Body>
                </Toast>

            </ToastContainer>


            {isSwal.status === true &&
                <SweetAlert
                    danger

                    confirmBtnText="Ok!"
                    //confirmBtnBsStyle="danger"
                    confirmBtnCssClass="custom-confirm-button-class"
                    onConfirm={() => { setIsSwal({ ...isSwal, status: false, message: "" }) }}
                >
                    <span className="fw-bold ">  {isSwal.message}</span>
                </SweetAlert>}

            <main id="main" className="main">

                <div className="pagetitle tab-fixed-header">
                    <h1 id='page-title'>File Monitoring</h1>
                </div>

                <section className="section mt-5">
                    <div className="row align-items-top   gap-2 gap-md-5">
                        <div className="col-lg-12">
                            <div className="card mb-5 mb-xl-8">
                                <div className='card-header'>
                                    <div className="d-flex align-items-center  position-relative ms-4">
                                        <FilterComponent
                                            formik={searchFormik}
                                            onReset={handleCustomReset}
                                            extraAction={
                                                <div className="d-flex" >
                                                    <div className="me-2">
                                                        <TableHeadings
                                                            columnState={state}
                                                            setColumnState={setState}
                                                        />
                                                    </div>
                                                    <button
                                                        onClick={() => {
                                                            if (searchFormik?.values?.created_date_range) {
                                                                let keymap = {
                                                                    rev_837_lockbox_count: "837 XFER RC",
                                                                    DATE: "CREATED DATE",
                                                                    rev_837_files_count: "837 FILES XFER RC",
                                                                    rev_eob_lockbox_count: "EOB XFER RC",
                                                                }
                                                                let header_names = columns?.map(item => (keymap?.[item?.id] ? keymap?.[item?.id] :
                                                                    item?.id.replaceAll('_', " ").trim()).toUpperCase()).join(',')

                                                                setExportLoader(true)
                                                                getFileMonitoringTable(pageNo, limit, searchFormik?.values, true, header_names)(response => {
                                                                    if (response?.status) {
                                                                        downloadFile(response?.data, `837 LockBox`)
                                                                    }
                                                                    setExportLoader(false)
                                                                })
                                                            } else {
                                                                searchFormik.setFieldTouched('created_date_range', true)
                                                                searchFormik.validateField('created_date_range')
                                                            }
                                                        }}
                                                        className="btn btn-light btn-active-primary pb-2  jobMonitor-Buttons"
                                                        type="button"
                                                    >
                                                        {exportLoader ? (
                                                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                        ) : (
                                                            <BiExport className="me-1" />
                                                        )}
                                                    </button>
                                                </div>
                                            }
                                        >
                                            <PartnerDropDown lockboxformik={searchFormik} name="partner" />
                                            <ClientDropDown lockboxformik={searchFormik} name="client" />
                                            <FacilityDropDown lockboxformik={searchFormik} name="facility" clients="client" />
                                            <Select
                                                isMulti
                                                className="basic-single select-search-facility"
                                                classNamePrefix="select"
                                                tabSelectsValue={false}
                                                closeMenuOnSelect={""}
                                                value={searchFormik.values?.zero_filter_type}
                                                name="zero_filter_type"
                                                components={{
                                                    DropdownIndicator: (props) => <DropdownIndicator {...props} state={name} />
                                                }}
                                                options={filemonitorfilter}
                                                onFocus={() => setIsFocusedPartner(true)}
                                                onBlur={() => setIsFocusedPartner(false)}
                                                onChange={handleSelectChange}
                                                placeholder="Select Status"
                                                styles={{
                                                    container: (styles) => ({
                                                        ...styles,
                                                        borderRadius: "9px",
                                                        width: '250px',
                                                    }),
                                                    placeholder: (styles) => ({
                                                        ...styles,
                                                        fontSize: '17px'
                                                    }),
                                                    control: (styles, state) => ({
                                                        ...styles,
                                                        backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                        borderStyle: "none",
                                                        boxShadow: "none",
                                                        borderRadius: "10px",
                                                        maxHeight: state.isFocused ? "auto" : "30px"
                                                    }),
                                                    indicatorSeparator: (styles) => ({
                                                        ...styles,
                                                        width: "0px",
                                                        minHeight: "20px"
                                                    }),
                                                    valueContainer: (styles, state) => ({
                                                        ...styles,
                                                        maxHeight: isFocusedPartner ? "auto" : "30px"
                                                    })
                                                }}
                                            />
                                            <div style={{width:'227px'}}>
                                                
                                            <DateRangePickerComponent
                                                tooltip="Created Date"
                                                value={searchFormik.values.created_date_range}
                                                name="created_date_range"
                                                handleChange={searchFormik.setFieldValue}
                                                error={searchFormik.errors.created_date_range}
                                                touched={searchFormik.touched.created_date_range}
                                                />
                                            </div>
                                        </FilterComponent>
                                        {/* <div className="d-flex" >
                                            <div className="me-2">

                                                <TableHeadings
                                                    columnState={state}
                                                    setColumnState={setState}
                                                />
                                            </div>
                                            <button className="btn btn-light btn-active-primary pb-2 dropdown-toggle  jobMonitor-Buttons" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <BiExport />
                                                <div className=" text-light" role="status">
                                                </div>

                                            </button>
                                        </div> */}


                                    </div>
                                </div>


                                <div className="card-body" style={{ padding: "0px 2.25rem" }}>
                                    <div className="table-responsive">
                                        <div className="dashboardtable">
                                            <DataTable
                                                key={searchKeyForTable}
                                                className="custom-datatable"
                                                fixedHeader={true}
                                                data={data?.results}
                                                columns={columns}
                                                progressPending={loading}
                                                pagination
                                                paginationServer
                                                highlightOnHover
                                                paginationTotalRows={totalRows}
                                                paginationPerPage={limit}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                conditionalRowStyles={conditionalRowStyles}
                                                onRowClicked={handleRowCheckClick}
                                                theme="solarized"
                                                customStyles={queueDatatableCustomStyles}
                                                onSort={handleSort}  
                                                sortServer 
                                                defaultSortAsc={ (searchedData?.sort_order ||" ").toUpperCase() === 'ASC' ?true :false}     // false = DESC , true = ASC
                                                onColumnOrderChange={handleColumnOrderChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>



            </main>
        </React.Fragment>




    )
}

export default FileMonitoring
